<template>
  <div>
    <b-navbar
      toggleable="lg"
      class="sbs-nav"
    >
      <b-navbar-brand>
        <a href="/"><img
            src="/img/logo/white_512.png"
            class="logo img-fluid"
          ></a>
      </b-navbar-brand>

      <b-navbar-toggle
        v-if="loggedIn"
        target="nav-collapse"
      >
        <template #default>
          <b-icon icon="list"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse
        id="nav-collapse"
        is-nav
      >
        <b-navbar-nav
          v-if="type === 'client'"
          class="ml-auto"
        >
          <b-nav-item>
            <router-link to="/dashboard">Dashboard</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/summary">Scorecard</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/documents">Documents</router-link>
          </b-nav-item>
          <b-nav-item-dropdown
            :text="username"
            right
          >
            <b-dropdown-item href="/help">Help Center</b-dropdown-item>
            <b-dropdown-item href="/contact">Contact Us</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="/account">Account Settings</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item>
            <MessageNotifications linkto="/feedback"></MessageNotifications>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav
          v-else-if="type === 'bookkeeper'"
          class="ml-auto"
        >
          <b-nav-item>
            <router-link to="/bookkeeping">Bookkeeping Queue</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/report">Reports</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/summary">Scorecard</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/documents">Documents</router-link>
          </b-nav-item>
          <b-nav-item-dropdown
            :text="username"
            right
          >
            <b-dropdown-item href="/dashboard">Dashboard</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="/account">Settings</b-dropdown-item>
            <b-dropdown-item href="/help">Help Center</b-dropdown-item>
            <b-dropdown-item @click="logout">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item>
            <MessageNotifications linkto="/messaging"></MessageNotifications>
            <MessageNotifications linkto="/feedback"></MessageNotifications>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav
          v-else-if="type === 'admin'"
          class="ml-auto"
        >
          <b-nav-item>
            <router-link to="/admin/onboarding">Onboarding</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/bookkeeping">Bookkeeper Queue</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link to="/report">Reports</router-link>
          </b-nav-item>

          <b-nav-item-dropdown
            text="Administration"
            right
          >
            <b-dropdown-item href="/admin/users">Users</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="/admin/company">Companies</b-dropdown-item>
            <b-dropdown-item href="/admin/industry">Industries</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="/admin/employee/activity">Employee Activity</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="/admin/templates">Templates</b-dropdown-item>
            <b-dropdown-item href="/admin/help">Help Admin</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown
            :text="username"
            right
          >
            <b-dropdown-item href="/dashboard">Dashboard</b-dropdown-item>
            <b-dropdown-item href="/summary">Scorecard</b-dropdown-item>
            <b-dropdown-item href="/documents">Documents</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="/account">Settings</b-dropdown-item>
            <b-dropdown-item href="/help">Help Center</b-dropdown-item>
            <b-dropdown-item @click="logout">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item>
            <MessageNotifications linkto="/messaging"></MessageNotifications>
            <MessageNotifications linkto="/feedback"></MessageNotifications>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav
          v-else
          class="ml-auto"
        >
          <b-nav-item v-if="loggedIn">
            <b-link @click.prevent="logout">Log Out</b-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div v-if="banner && banner.active" class="banner-alert" role="alert" >
      <div class="banner-inner">
        <strong v-if="banner.title" class="banner-title">
          {{ banner.title }}
        </strong>
        <span class="banner-message" v-html="banner.message"></span>
      </div>
    </div>
  </div>
</template>
<script>
import UserService from '@/services/UserService'
import CompanyService from '@/services/CompanyService'
import MessageNotifications from '@/components/messaging/Notifications'

export default {
  name: 'Navigation',
  components: { MessageNotifications },
  props: {
    type: {
      type: String,
      default: 'anonymous'
    }
  },

  data () {
    return {
      userinfo: null,
      username: null,
      banner: null
    }
  },

  mounted () {
    this.setname()
    this.loadBanner()
  },

  methods: {
    logout () {
      UserService.logout()
    },

    async setname () {
      this.userinfo = await UserService.getUserInfo()

      if (this.userinfo && this.userinfo.apitoken) {
        this.username = this.userinfo.firstname + ' ' + this.userinfo.lastname
      }
    },
    async loadBanner () {
      try {
        if (!UserService.isLoggedIn()) return
        if (!this.userinfo) {
          this.userinfo = await UserService.getUserInfo()
        }
        const companyId = this.userinfo?.company_id ?? null
        const res = await CompanyService.getBanner(companyId)
        this.banner = res?.data?.info?.banner || null
      } catch (e) {
        this.banner = null
      }
    },
    hideUnreadMessagesAlert () {
      return UserService.hideUnreadMessagesAlert()
    }
  },

  computed: {
    loggedIn () {
      return UserService.isLoggedIn()
    }
  }
}
</script>
<style>
.banner-alert{
  width: 100%;
  background: #fff3cd;
  border-bottom: 1px solid #ffeeba;
  color: #856404;
}
.banner-inner{
  max-width: 100%;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px;
}
.banner-title{
  font-weight: 700;
}
.banner-message{
  line-height: 1.3;
}
</style>
